import { AxiosPromise, AxiosResponse } from "axios";
import { Interceptors } from "./interceptors";
import { message, Modal } from 'ant-design-vue'
// 请求配置
export class HttpServer {
  axios: any;
  // 获取axios实例
  constructor() {
    this.axios = new Interceptors().getInterceptors();
  }
  // 简单封装一下方法
  request(config: any, isThrowErrMsg: boolean = true): AxiosPromise {
    return new Promise((resolve, reject) => {
      this.axios(config).then((res: AxiosResponse) => {
        const responseType = res?.request?.responseType
        if (res.data instanceof Blob) {
          resolve(res);
          return;
        }
        if (res.success) {
          resolve(res);
        } else {

          if (responseType === 'blob') {
            Modal.info({
              title: 'Error',
              content: res.failMsg || res.message
            })
            reject(res)
          }
          if (['content-pin-too-many-fail-msg'].includes(res.failMsgType)) {
            resolve(res);
          } else {
            if (res.failMsgType !== 'fail-msg-need-user-confirm' && isThrowErrMsg) message.error(res.failMsg || res.message)
            reject(res)
          }
        }
      }).catch((err: any) => {
        reject(err)
      });
    });
  }
}

const http = new HttpServer()

export default http